import React from 'react';
import {
  SearchErrorImage,
  ErrorHeadingStyles,
  ErrorDescriptionStyles,
  ButtonStyles,
} from './styles/ShowError.styles';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import options from '../../../../helpers/ContentFulOptions';
import Button from '@legacy-vfuk/core-button';
import { navigate } from 'gatsby';
import { ErrorDataTypes } from './Types/ShowError.types';

const ShowError = ({ errorContent, customParam }: ErrorDataTypes) => {
  const errorImage = errorContent?.errorImage?.file?.url;
  const errorHeading = errorContent?.errorHeading?.errorHeading;
  const errorDescription = errorContent?.errorDescription?.raw;
  const defaultAppearance = 'primary';
  let errorDescriptionRaw;

  if (errorDescription) {
    errorDescriptionRaw = documentToReactComponents(
      JSON.parse(errorDescription),
      options
    );
  }

  const customRetryBtnAction = () => {
    if (customParam) {
      customParam();
    }
  };

  /**
   *   TODO: Content model for `Section Element - CTA button` requires updating from dcl to SourceWeb attributes
   *   Need to add correct the props such as remove all unused dcl attributes e.g. replace rank with appearance
   *   And align with all the SourceWeb button props
   *   https://github.vodafone.com/pages/Vodafone-Digital-Universe/source-web/index.html#/Components/Atoms/Interactions/Button
   *   Then in the code update all related props and types
   */

  // this regular expression is to ensure that these dcl attributes will be translated to 'primary' attribute for SW button
  const regEx = /^(tertiary|none|transparent)$/;
  if (
    errorContent?.retryButton?.rank &&
    regEx.test(errorContent?.retryButton?.rank)
  ) {
    errorContent.retryButton.rank = defaultAppearance;
  }
  if (
    errorContent?.restartButton?.rank &&
    regEx.test(errorContent?.restartButton?.rank)
  ) {
    errorContent.restartButton.rank = defaultAppearance;
  }

  return (
    <div data-testid="errorScreen">
      {errorImage && <SearchErrorImage src={errorImage}></SearchErrorImage>}
      <ErrorHeadingStyles>{errorHeading}</ErrorHeadingStyles>
      <ErrorDescriptionStyles>{errorDescriptionRaw}</ErrorDescriptionStyles>
      <ButtonStyles>
        {errorContent?.retryButton && (
          <Button
            text={errorContent?.retryButton?.label ?? 'Retry'}
            appearance={errorContent?.retryButton?.rank ?? defaultAppearance}
            onClick={() => {
              customRetryBtnAction();
            }}
          />
        )}
        {errorContent?.restartButton && (
          <Button
            text={errorContent?.restartButton?.label ?? 'Restart'}
            appearance={errorContent?.restartButton?.rank ?? defaultAppearance}
            onClick={() => {
              navigate(`${errorContent?.restartButton?.url}`);
            }}
          />
        )}
      </ButtonStyles>
    </div>
  );
};

export default ShowError;
